import _classCallCheck from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { DEFAULT_WIDTH, DEFAULT_HEIGHT } from "../constants.js";
;
var Map = /*#__PURE__*/function () {
  /**
   * @class Base map generator
   * @param {int} [width=ROT.DEFAULT_WIDTH]
   * @param {int} [height=ROT.DEFAULT_HEIGHT]
   */
  function Map() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_WIDTH;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_HEIGHT;
    _classCallCheck(this, Map);
    this._width = width;
    this._height = height;
  }
  _createClass(Map, [{
    key: "_fillMap",
    value: function _fillMap(value) {
      var map = [];
      for (var i = 0; i < this._width; i++) {
        map.push([]);
        for (var j = 0; j < this._height; j++) {
          map[i].push(value);
        }
      }
      return map;
    }
  }]);
  return Map;
}();
export { Map as default };